const routes = {
    root: '/',
	api: {
		root: '/api',
		spec: '/api/spec',
		ThreeDSecure : '/api/ThreeDSecure',
		webhooks: '/api/webhooks',
		batch: {
			root: '/api/batch'
		},
		biller: {
			root: '/api/biller'
		},
		tokens: {
			root: '/api/tokens'
		},
		paymentRequest: {
			root: '/api/payment-request'
		},
		reporting: {
			root: '/api/reporting'
		},
		twoPartyTxnProcessing: {
			root: '/api/2-party-txn-processing'
		},
		txn: {
			root: '/api/txn',
			authkey: {
				overview: '/api/txn/overview',
				gettingStarted: '/api/txn/gettingStarted',
				flow: '/api/txn/flow',
				javascriptSimple: '/api/txn/authkey/payment-method/javascript/simple',
				javascriptAdvanced: '/api/txn/authkey/payment-method/javascript/advanced',
				iframeFields: '/api/txn/authkey/payment-method/iframe-fields',
				hpp: '/api/txn/authkey/payment-method/hpp',
				authentication: '/api/txn/authkey/authentication',
				klarna: '/api/txn/authkey/klarna',
				applepay: '/api/txn/authkey/applepay',
				googlepay: '/api/txn/authkey/googlepay',
				avs: '/api/txn/authkey/avs',
			},
		},
		twoparty: {
			root: '/api/twoparty'
		},
		twoPartyTokenProcessing: {
			root: '/api/2-party-token-processing'
		},
		twopartytoken: {
			root: '/api/twopartytoken'
		},
		token: {
			root: '/api/token',
			authkey: {
				overview: '/api/token/overview',
				gettingStarted: '/api/token/gettingStarted',
				flow: '/api/token/flow',
				javascriptSimple: '/api/token/authkey/payment-method/javascript/simple',
				javascriptAdvanced: '/api/token/authkey/payment-method/javascript/advanced',
				iframeFields: '/api/token/authkey/payment-method/iframe-fields',
			},
		},
	},
	reference: {
		bankResponseCodes: '/reference/bank-response-codes',
		avsResultCodes: '/reference/avs-result-codes',
		testMode: '/reference/test-mode',
		threeds: '/reference/threeds',
		countryCodes: '/reference/country-codes',
		currencyCodes: '/reference/currency-codes',
	},
	getstarted: {
		openapigenerator: '/getstarted/openapigenerator',
		quickstart: '/getstarted/quickstart',
	},
	plugins: {
		root: '/plugins'
	}
};

export default routes;